import React, { useState } from 'react';
import { Package, BoxIcon, Layers, Image as ImageIcon, X } from 'lucide-react';
import AddNewBannerPopup from '../BannerPopup/AddNewBannerPopup ';

const AddCategoryPopup = ({ isVisible, onClose, onCategoryTypeSelect }) => {
  const [showBannerPopup, setShowBannerPopup] = useState(false);

  if (!isVisible) return null;

  const categoryTypes = [
    {
      id: 'quantity',
      label: 'الكمية',
      icon: BoxIcon
    },
    {
      id: 'package',
      label: 'الباقات',
      icon: Package
    },
    {
      id: 'stock',
      label: 'المخزون',
      icon: Layers
    },
    {
      id: 'banner',
      label: 'إضافة بانر',
      icon: ImageIcon
    }
  ];

  const handleTypeSelect = (type) => {
    if (type === 'banner') {
      setShowBannerPopup(true);
    } else {
      onCategoryTypeSelect(type);
    }
  };

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80" dir="rtl">
        <div className="bg-gray-900 p-6 rounded-xl shadow-xl w-full max-w-md border border-gray-800">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-bold text-white">اختر نوع التصنيف</h2>
            <button
              onClick={onClose}
              className="p-2 rounded-lg bg-gray-800/50 hover:bg-gray-700/50 transition-colors"
            >
              <X className="w-5 h-5 text-gray-400" />
            </button>
          </div>

          <div className="grid grid-cols-1 gap-4">
            {categoryTypes.map((type) => {
              const Icon = type.icon;
              return (
                <button
                  key={type.id}
                  onClick={() => handleTypeSelect(type.id)}
                  className="flex items-center gap-3 p-4 bg-gray-800/50 hover:bg-gray-700/50 rounded-lg transition-colors group"
                >
                  <div className="p-2 bg-yellow-500/10 rounded-lg group-hover:bg-yellow-500/20 transition-colors">
                    <Icon className="w-5 h-5 text-yellow-500" />
                  </div>
                  <span className="text-white font-medium">{type.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {showBannerPopup && (
        <AddNewBannerPopup
          isVisible={showBannerPopup}
          onClose={() => {
            setShowBannerPopup(false);
            onClose();
          }}
        />
      )}
    </>
  );
};

export default AddCategoryPopup;